import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./plugins/i18n";

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';

import './assets/css/GlobalVariables.scss';

import { storeDeepData, myData, sortDifference , commonUpdateRequest } from "./utils/partialUpdate.js"; // partial update request utilities
import { startTimer, timerDone } from "./utils/cooldownTimer.js"; // timer utilities
import { sortAlphabetically, sortNumerically, sortDates } from "./utils/sortArray.js"; // table sorter utilities
import { isUnitEmpty } from "./utils/isUnityEmpty.js"; // for kpi units sorting

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueToast);

Vue.prototype.$storeDeepData = storeDeepData; // partial update request utilities
Vue.prototype.$storedData = myData; // partial update request utilities
Vue.prototype.$sortDifference = sortDifference; // partial update request utilities
Vue.prototype.$updateRequest = commonUpdateRequest; // partial update request utilities

Vue.prototype.$startTimer = startTimer; // timer utilities 
Vue.prototype.$timerDone = timerDone; // timer utilities

Vue.prototype.$sortAlphabetically = sortAlphabetically; // table sorter utilities
Vue.prototype.$sortNumerically = sortNumerically; // table sorter utilities
Vue.prototype.$sortDates = sortDates; // table sorter utilities

Vue.prototype.$isUnitEmpty = isUnitEmpty; // for kpi units sorting

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
